<template>
  <!-- 如果有子元素 -->
  <template v-if="menuItem.children?.length && !disabled">
    <a-sub-menu
      :key="menuItem.title"
      transition-name=""
      class="bg-black !m-0"
      :style="{
        width: width + 'px'
      }"
    >
      <template #title>
        <menu-title :menu-item="menuItem" :disabled="disabled" />
      </template>
      <template v-for="menu in menuItem.children" :key="menu.title">
        <menu-item v-if="!menu.hidden" :menu-item="menu" :width="width" />
      </template>
    </a-sub-menu>
  </template>

  <!-- 没有子元素 -->
  <template v-else>
    <!-- 显示分隔符 -->
    <div v-if="menuItem.delimiter" class="px-4 my-2">
      <small
        v-if="typeof menuItem.delimiter == 'string'"
        class="text-white opacity-50"
        >{{ menuItem.delimiter }}</small
      >
      <div v-else class="border-t border-black-50" />
    </div>
    <!-- 非分隔符 -->
    <a-menu-item
      v-else
      class="!p-0 !m-0"
      :style="{
        width: width + 'px'
      }"
      @click="onClick"
    >
      <menu-title :menu-item="menuItem" :disabled="disabled" />
    </a-menu-item>
  </template>
</template>
<script lang="ts">
import { PropType, defineComponent, computed } from 'vue';
import MenuTitle from './MenuTitle.vue';
import { emitter, EventType } from '@/utils/emitter.utils';

export default defineComponent({
  components: { MenuTitle },
  props: {
    menuItem: {
      type: Object as PropType<DropDownMenuItem>,
      default: () => ({})
    },
    width: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const disabled = computed(() => {
      if (props.menuItem.disabled == undefined) return false;
      if (typeof props.menuItem.disabled == 'boolean')
        return props.menuItem.disabled;
      return !!props.menuItem.disabled?.(props.menuItem);
    });
    return {
      disabled,
      onClick: () => {
        emitter.emit(EventType['dropdown:visibleChange'], false);
        if (disabled.value) return;
        try {
          props.menuItem?.onClick?.();
        } catch (error) {
          console.error(error);
        }
      }
    };
  }
});
</script>
